import { Translation } from "../model/Language.js";
import { BaseElementOptions, BaseElement } from "./BaseElement.js";


export interface AppErrorOptions extends BaseElementOptions {
    error?: any;
    message: Translation;
    icon?: string;
    content?: Translation;
}

export class AppError extends BaseElement {

    public create(options: AppErrorOptions):this {

        options = e5.object.merge({
            icon: "fal fa-exclamation-triangle"
        } as AppErrorOptions, options);

        super.create(options);
        this.setElement(this.createElement());

        var c = document.createElement("div");
        c.className = "awi-app-error__content";
        this.element.appendChild(c);

        var icon = document.createElement("div");
        icon.className = "awi-app-error__icon " + options.icon;
        c.appendChild(icon);

        var m = document.createElement("div");
        m.className = "awi-app-error__message";
        lang.set(m, options.message);
        c.appendChild(m);

        if(options.content){
            var m = document.createElement("div");
            m.className = "awi-app-error__message";
            lang.set(m, options.content);
            c.appendChild(m);
        }

        if (options.error && window.errorView) {
            window.errorView.add(options.error, "apperror");
        }

        return this;
    }

    protected createElement(): HTMLDivElement {
        var e = document.createElement("div");
        e.className = "awi-app-error";
        return e;
    }
}